/* 🤖 this file was generated by svg-to-ts */
export const siriusFlagRo: {
  name: 'flag_ro';
  data: string;
} = {
  name: 'flag_ro',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24" style="display: block;"><g clip-path="url(#a)"><path fill="#00319C" d="M0 0h10.665v24H0V0Z"/><path fill="#FFDE00" d="M10.665 0h10.67v24h-10.67V0Z"/><path fill="#DE2110" d="M21.335 0H32v24H21.335V0Z"/></g><rect width="31" height="23" x=".5" y=".5" stroke="#000" stroke-opacity=".2" rx="2.5"/><defs><clipPath id="a"><rect width="32" height="24" fill="#fff" rx="3"/></clipPath></defs></svg>`
};
